import { render, staticRenderFns } from "./program-units.vue?vue&type=template&id=02ed7a22&"
import script from "./program-units.vue?vue&type=script&lang=js&"
export * from "./program-units.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports